import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DomainManagementTable from './domain-management-table';

import {
    filterDomainManagementTable,
    paginateDomainManagementTable,
    sortDomainManagementTable
} from '../actions/domain-management-table-action-creators';

export class DomainManagementTableContainer extends Component{
    render(){
        const {
            data,
            columnDefs,
            isActiveTable,
            domainGroups,
            filterDomainManagementTable,
            isLoading,
            selectedDomainFilter,
            orgDomainSelectData,
            onRowClick,
            totalItemCount,
            handleViewButtonAction,
            paginateDomainManagementTable,
            sortDomainManagementTable,
            type,
        } = this.props;

        return (
            <DomainManagementTable
                columnDefs={columnDefs}
                data={data}
                domainGroups={ domainGroups }
                handleOrgDomainMultiSelectFilter={filterDomainManagementTable}
                handleFilterChange={filterDomainManagementTable}
                handlePaginationChange={paginateDomainManagementTable}
                handleSortChange={sortDomainManagementTable}
                isActiveTable={isActiveTable}
                isLoading={isLoading}
                onRowClick={onRowClick}
                handleViewButtonAction={handleViewButtonAction}
                orgDomainSelectData={orgDomainSelectData}
                selectedDomainFilter={selectedDomainFilter}
                totalItemCount={ totalItemCount}
                type={type}
            />
        );
    }
};

const mapDispatchToProps = {
    filterDomainManagementTable,
    paginateDomainManagementTable,
    sortDomainManagementTable
};

DomainManagementTableContainer.propTypes = {
    columnDefs: PropTypes.array,
    data: PropTypes.array.isRequired,
    domainGroups: PropTypes.array,
    filterDomainManagementTable: PropTypes.func.isRequired,
    handleViewButtonAction: PropTypes.func,
    isActiveTable: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    onRowClick: PropTypes.func,
    orgDomainSelectData: PropTypes.array,
    paginateDomainManagementTable: PropTypes.func.isRequired,
    selectedDomainFilter: PropTypes.string,
    sortDomainManagementTable: PropTypes.func.isRequired,
    totalItemCount: PropTypes.number,
    type: PropTypes.string.isRequired,
};

export default connect( null , mapDispatchToProps )( DomainManagementTableContainer );
